import * as React from 'react';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import Input from './../components/Input/Input';
import { postData, putData } from '../actions/developer';
import * as _ from 'lodash';
import { Select, notification, Tabs, Table } from 'antd';
import { getDataBy } from '../actions/apiCall';
import moment from 'moment';
import { DeleteTwoTone, PlusCircleTwoTone } from '@ant-design/icons';
import { connect } from 'react-redux';

// import { icons } from './Navbar/Navbar';
import { decryptData } from '../actions/crypto';

const { TabPane } = Tabs;
const { Option } = Select;
interface Props {
  className?: string;
  children?: any;
  columns?: any;
  data?: any;
  onSubmitForm?: any;
  id?: any;
  dispatch?: any;
  apiData?: any;
  onCloseModal?: any;
  isView?: any;
  formData?: any;
  onFilterData?: any;
  formInstructions?: any;
  title?: string;
  requireAuth?: boolean;
  requireNoAuth?: boolean;
  requireGlobalAdmin?: boolean;
  isNotRedirected?: boolean;
  isLoaded?: boolean;
  isAuthenticated?: boolean;
  isGlobalAdmin?: boolean;
  user?: any;
  history?: any;
  showResult?: any;
}

interface States {
  changeForm: any;
  touched: any;
  apiData: any;
  combo: any;
  children: any;
  selectedTab: any;
  loading: boolean;
  _values?: any;
  selectedSubTab?: any;
  _responseData?: any;
}

const openNotificationWithIcon = (type, title, message) => {
  notification[type]({
    message: title,
    description: message,
  });
};
class SimpleForm extends React.Component<Props, States> {
  searchInput: any;
  constructor(props) {
    super(props);
    this.state = {
      selectedTab: 0,
      changeForm: false,
      touched: {},
      apiData: this.props.apiData,
      combo: {},
      children: this.getPropsValue(),
      loading: false,
      _values: {},
      selectedSubTab: false,
      _responseData: []
    };
  }

  getPropsValue(data = null) {
    const { children } = this.props;
    let { apiData } = this.props;
    const chiled = children;
    const { isTabView } = this.props.children;
    let activeTab = 0;
    if (this.state) {
      const { selectedTab } = this.state;
      activeTab = selectedTab;
    }
    if (data) {
      apiData = data;
    }
    const childrens =
      chiled &&
      (isTabView
        ? chiled.getFormColumns()[activeTab].getChiledForm()
        : chiled.getFormColumns()
      ).filter((ele) => ele.type == 'form');
    if (apiData && Object.keys(apiData).length > 0) {
      childrens.forEach((element) => {
        if (apiData[element.dataIndex]) {
          apiData[element.dataIndex].forEach((_ele, index) => {
            if (index + 1 < apiData[element.dataIndex].length) {
              element.form.push(element.form[0]);
            }
          });
        }
      });
    }
    return childrens;
  }

  componentDidMount(): void {
    const { children } = this.props;
    if (children.combo && children.combo.length > 0) {
      this.getCombo();
    }
  }

  componentWillReceiveProps() {
    console.log('props.id', this.props);
    const { id, apiData } = this.props;
    if (id) {
      this.setState({ apiData });
    }
  }

  extractValues(object, keys, isJoin) {
    const result = [];
    function recursiveExtract(obj, keyObj, keyPath) {
      for (const key in keyObj) {
        const newKeyPath = keyPath ? keyPath + '.' + key : key;
        if (typeof keyObj[key] === 'object') {
          recursiveExtract(obj[key], keyObj[key], newKeyPath);
        } else if (keyObj[key] === 1 && obj[key] !== undefined) {
          result.push(obj[key]);
        }
      }
    }
    if (typeof keys === 'string') {
      if (object[keys] !== undefined) {
        return object[keys];
      }
    } else {
      recursiveExtract(object, keys, '');
      return result.join(isJoin ? isJoin : ' ');
    }
  }

  getCombo(dataIndex = null, paramValue = null) {
    const { children } = this.props;
    if (children && children.combo) {
      children.combo.forEach(async (element) => {
        if (!element.paramValue && !element.dependent) {
          const data = await this.props.dispatch(getDataBy(element.api));
          if (element.isEcrypted) {
            data.data = decryptData(data.data);
          }
          if (data && data?.data.length > 0) {
            const params = {};
            params[element.name] = data?.data?.map((ele) => ({
              id: ele[element.idKey],
              name: (element && element.render) ? element.render(ele) : Array.isArray(element.nameKey)
                ? element.nameKey
                  .map((key) => this.extractValues(ele, key, element.isJoin))
                  .join(element.isJoin ? element.isJoin : ' ')
                : ele[element.nameKey],
            }));
            this.setState({ combo: { ...this.state.combo, ...params } });
          }
        } else if (element.paramValue && dataIndex && dataIndex == element.paramValue) {
          const data = await this.props.dispatch(
            getDataBy(element.api + paramValue)
          );
          if (element.isEcrypted) {
            data.data = decryptData(data.data);
          }
          if (data && data?.data.length > 0) {
            const params = {};
            params[element.name] = data?.data?.map((ele) => ({
              id: ele[element.idKey],
              name: (element && element.render) ? element.render(ele) : Array.isArray(element.nameKey)
                ? element.nameKey.map((key) => this.extractValues(ele, key, element.isJoin)).join(element.isJoin ? element.isJoin : ' ')
                : ele[element.nameKey],
            }));
            this.setState({ combo: { ...this.state.combo, ...params } });
          }
        } else if (element.dependent && dataIndex && dataIndex == element.dependent) {
          const data = await this.props.dispatch(
            getDataBy(element.api + paramValue)
          );
          if (data) {
            console.log('datadata', data);
            // const params = {};
            // params[element.name] = data.data.map((ele) => ({
            //   id: ele[element.idKey],
            //   name: Array.isArray(element.nameKey)
            //     ? element.nameKey.map((key) => ele[key]).join(" ")
            //     : ele[element.nameKey],
            // }));
            // this.setState({ combo: { ...this.state.combo, ...params } });
          }
        }
      });
    }
  }

  addMore = (chiledForm, dataIndex, _values) => {
    const { children } = this.state;
    children.forEach((element) => {
      if (element.dataIndex == dataIndex) {
        element.form.push(chiledForm);
      }
    });
    console.log('_values_values_values', _values);
    this.setState({ children, _values });
  };

  onDeleteRow = (dataIndex, index, _values) => {
    const { children } = this.state;
    children.forEach((element) => {
      if (element.dataIndex == dataIndex) {
        element.form.splice(index, 1);
      }
    });
    this.setState({ children, _values });
  };

  onChangeCalled = (e, dataIndex) => {
    console.log('e, dataIndexe, dataIndexe, dataIndex', e, dataIndex);
    this.getCombo(dataIndex, e);
  };

  getApproval = (ele, fields) => {
    if (fields && fields.approvalFrom && this.props.user._id == fields.approvalFrom) {
      return ele.hideFromOther ? true : !ele.hideFromApproval;
    } else {
      return !ele.hideFromOther;
    }
  };

  callRefreshAPI = (parameters, row) => {
    console.log('rowrowrow', parameters, row);
  };

  getFormsInput = (errors, touched, _isSubmitting, fields, isView, values) => {
    const { getFormColumns, isTabView } = this.props.children;
    const { selectedTab } = this.state;

    return (
      <div className="row">
        {(isTabView
          ? getFormColumns()[selectedTab].getChiledForm().filter(ele => this.getApproval(ele, fields))
          : getFormColumns().filter(ele => this.getApproval(ele, fields))
        ).map((ele) => {
          const {
            type,
            key,
            title,
            formClassName,
            children,
            multiple,
            lebelInstructions,
            heading,
            dataIndex,
            onChangeFieldValue
          } = ele;
          const { combo } = this.state;
          if (type == 'form') {
            const { children: formChiled } = this.state;
            return (
              <div className="col-12 pb-2 row pl-4">
                {heading && (
                  <div className="col-12">
                    <b>{title}</b>
                  </div>
                )}
                <div className="col-12 row margin-box">
                  {formChiled
                    .filter((ele) => ele.dataIndex == dataIndex)[0]
                    .form.map((element, index) => {
                      return (
                        <>
                          <div className="col-10 row inner-box">
                            {element.map((rows) => {
                              const {
                                type,
                                key,
                                title,
                                formClassName,
                                children,
                                multiple,
                                lebelInstructions,
                                onChangeFieldValue
                              } = rows;
                              let defaultValue;
                              if (
                                fields[dataIndex].length > index &&
                                (fields[dataIndex][index][key] ||
                                  fields[dataIndex][index][key] == 0)
                              ) {
                                defaultValue = fields[dataIndex][index][key];
                                if (type === 'date') {
                                  defaultValue = moment(
                                    fields[dataIndex][index][key]
                                  );
                                }
                              }
                              return (
                                <>
                                  <div
                                    className={
                                      formClassName
                                        ? formClassName
                                        : 'col-12 pb-2'
                                    }
                                  >
                                    <Input
                                      callRefreshAPI={(e) => this.callRefreshAPI(e, rows)}
                                      label={title}
                                      name={`${dataIndex}[${index}].${key}`}
                                      disabled={isView ? isView : undefined}
                                      defaultValue={defaultValue}
                                      multiple={multiple}
                                      type={type ? type : 'text'}
                                      extra={_.omitBy(ele, [
                                        'type',
                                        'title',
                                        'key',
                                      ])}
                                      touched={touched}
                                      apis={this.props.children.combo}
                                      dispatch={this.props.dispatch}
                                      lebelInstructions={lebelInstructions}
                                      errors={errors}
                                      index={index}
                                      {...rows}
                                      onChange={(e) =>
                                        this.onChangeCalled(e, key)
                                      }
                                      onChangeFieldValue={onChangeFieldValue}
                                    >
                                      {((children && !multiple) ||
                                        (combo[key] && !multiple)) && (
                                          <Option value="" disabled>
                                            Select a {title}
                                          </Option>
                                        )}
                                      {!combo[key] &&
                                        children &&
                                        children.map((options) => {
                                          return (
                                            <Option value={options.name}>
                                              {options.value}
                                            </Option>
                                          );
                                        })}
                                      {combo[key] &&
                                        combo[key].map((options) => {
                                          return (
                                            <Option value={options.id}>
                                              {options.name}
                                            </Option>
                                          );
                                        })}
                                    </Input>
                                  </div>
                                </>
                              );
                            })}
                          </div>
                          {!isView && (
                            <div className="col-2">
                              {formChiled.filter(
                                (ele) => ele.dataIndex == dataIndex
                              )[0].form.length > 1 && (
                                  <DeleteTwoTone
                                    style={{
                                      fontSize: '25px',
                                      padding: '14px 5px',
                                      verticalAlign: 'middle !important',
                                    }}
                                    onClick={() =>
                                      this.onDeleteRow(dataIndex, index, values)
                                    }
                                  />
                                )}
                              <PlusCircleTwoTone
                                style={{
                                  fontSize: '25px',
                                  padding: '14px 5px',
                                  verticalAlign: 'middle !important',
                                }}
                                onClick={() => this.addMore(element, dataIndex, values)}
                              />
                            </div>
                          )}
                        </>
                      );
                    })}
                </div>
              </div>
            );
          } else if (type == 'tabs') {
            const { tabs } = ele;
            // const { children: formChiled } = this.state;
            return (
              <div className="col-12 pb-2 row pl-4">
                {heading && (
                  <div className="col-12">
                    <b>{title}</b>
                  </div>
                )}
                <div className="col-12 row margin-box">
                  <Tabs
                    defaultActiveKey={this.state.selectedSubTab}
                    onChange={this.setCurrentSubTabView}
                  >
                    {tabs.map((element, index) => {
                      return (
                        <TabPane
                          tab={element.tabName}
                          key={index}
                          disabled={false}
                        >
                          <>
                            <div className="col-10 row inner-box">
                              {element.getChiledForm().map((rows) => {
                                const {
                                  type,
                                  key,
                                  title,
                                  formClassName,
                                  children,
                                  multiple,
                                  lebelInstructions,
                                } = rows;
                                let defaultValue;
                                if (
                                  fields[dataIndex].length > index &&
                                  (fields[dataIndex][index][key] ||
                                    fields[dataIndex][index][key] == 0)
                                ) {
                                  defaultValue = fields[dataIndex][index][key];
                                  if (type === 'date') {
                                    defaultValue = moment(
                                      fields[dataIndex][index][key]
                                    );
                                  }
                                }
                                return (
                                  <>
                                    <div
                                      className={
                                        formClassName
                                          ? formClassName
                                          : 'col-12 pb-2'
                                      }
                                    >
                                      <Input
                                        callRefreshAPI={(e) => this.callRefreshAPI(e, rows)}
                                        label={title}
                                        name={`${dataIndex}[${index}].${key}`}
                                        disabled={isView ? isView : undefined}
                                        defaultValue={defaultValue}
                                        multiple={multiple}
                                        type={type ? type : 'text'}
                                        extra={_.omitBy(ele, [
                                          'type',
                                          'title',
                                          'key',
                                        ])}
                                        touched={touched}
                                        apis={this.props.children.combo}
                                        dispatch={this.props.dispatch}
                                        lebelInstructions={lebelInstructions}
                                        errors={errors}
                                        index={index}
                                        {...rows}
                                        onChange={(e) =>
                                          this.onChangeCalled(e, key)
                                        }
                                        onChangeFieldValue={onChangeFieldValue}
                                      >
                                        {((children && !multiple) ||
                                          (combo[key] && !multiple)) && (
                                            <Option value="" disabled>
                                              Select a {title}
                                            </Option>
                                          )}
                                        {!combo[key] &&
                                          children &&
                                          children.map((options) => {
                                            return (
                                              <Option value={options.name}>
                                                {options.value}
                                              </Option>
                                            );
                                          })}
                                        {combo[key] &&
                                          combo[key].map((options) => {
                                            return (
                                              <Option value={options.id}>
                                                {options.name}
                                              </Option>
                                            );
                                          })}
                                      </Input>
                                    </div>
                                  </>
                                );
                              })}
                            </div>
                          </>
                        </TabPane>
                      );
                    })}
                  </Tabs>
                </div>
              </div>
            );
          } else {
            let defaultValue = fields[key];
            if (fields[key]) {
              if (type === 'date') {
                defaultValue = moment(fields[key]);
              }
            }
            return (
              <>
                <div className={formClassName ? formClassName : 'col-12 pb-2'}>
                  <Input
                    callRefreshAPI={(e) => this.callRefreshAPI(e, ele)}
                    label={title}
                    name={key}
                    disabled={isView ? isView : undefined}
                    defaultValue={defaultValue}
                    multiple={multiple}
                    type={type ? type : 'text'}
                    extra={_.omitBy(ele, ['type', 'title', 'key'])}
                    touched={touched}
                    apis={this.props.children.combo}
                    dispatch={this.props.dispatch}
                    lebelInstructions={lebelInstructions}
                    errors={errors}
                    onChange={(e) => this.onChangeCalled(e, dataIndex)}
                    onChangeFieldValue={onChangeFieldValue}
                    {...ele}
                  >
                    {((children && !multiple) || (combo[key] && !multiple)) && (
                      <Option value="" disabled>
                        Select a {title}
                      </Option>
                    )}
                    {!combo[key] &&
                      children &&
                      children.map((options) => {
                        return (
                          <Option value={options.name}>
                            {options.icon && (
                              <>
                                {options.value}
                              </>
                            )}
                            {!options.icon && <>{options.value}</>}
                          </Option>
                        );
                      })}
                    {combo[key] &&
                      combo[key].map((options) => {
                        return (
                          <Option value={options.id}>{options.name}</Option>
                        );
                      })}
                  </Input>
                </div>
              </>
            );
          }
        })}
      </div>
    );
  };

  getDefaultFields = () => {
    const { getFormColumns, isTabView } = this.props.children;
    const { selectedTab, apiData, _values } = this.state;
    const fields = {};
    (isTabView
      ? getFormColumns()[selectedTab].getChiledForm()
      : getFormColumns()
    ).map((x) => {
      if (apiData) {
        fields[x.dataIndex] =
          apiData[x.dataIndex] !== undefined
            ? apiData[x.dataIndex]
            : x.hasOwnProperty('defaultValue')
              ? x.defaultValue
              : '';
      } else {
        if (x.type == 'form') {
          const { children } = this.state;
          fields[x.dataIndex] = [];
          const formKeys = {};
          (children && children.length ? children : this.getPropsValue())
            .filter((ele) => ele.dataIndex == x.dataIndex)[0]
            .form.forEach((ele) => {
              ele.forEach((element) => {
                formKeys[element.dataIndex] = x.hasOwnProperty('defaultValue')
                  ? x.defaultValue
                  : '';
              });
              fields[x.dataIndex].push(formKeys);
            });
        } else {
          fields[x.dataIndex] = x.hasOwnProperty('defaultValue')
            ? x.defaultValue
            : '';
        }
      }
    });
    return this.fillEmptyFieldsWithDefaults(fields, _values);
  };

  fillEmptyFieldsWithDefaults(defaults, inputData) {
    const result = { ...defaults };
    for (const key in inputData) {
      if (inputData.hasOwnProperty(key)) {
        if (typeof inputData[key] === 'object' && inputData[key] !== null) {
          result[key] = Array.isArray(inputData[key])
            ? inputData[key]
            : { ...defaults[key], ...inputData[key] };
        } else if (inputData[key] !== '') {
          result[key] = inputData[key];
        }
      }
    }
    return result;
  }

  setCurrentTabView = (e) => {
    this.setState({ selectedTab: e, loading: true }, () => this.getAPICall());
  };

  setCurrentSubTabView = (e) => {
    this.setState({ selectedSubTab: e });
  };

  getAPICall = async () => {
    const { getFormColumns } = this.props.children;
    const { formData } = this.props;
    const { selectedTab } = this.state;
    const { api, getValue } = getFormColumns()[selectedTab];
    if (api && formData) {
      const responseData = await this.props.dispatch(
        getDataBy(
          `${api}/${(getValue && getValue(formData)) || formData['_id']}`
        )
      );
      if (responseData) {
        this.setState({
          apiData: responseData.data,
          children: this.getPropsValue(responseData.data),
          loading: false,
        });
      }
    } else {
      this.setState({
        apiData: null,
        children: this.getPropsValue(),
        loading: false,
      });
    }
  };

  getTableResponse = (responseData) => {
    return [
      {
        key: '1',
        description: 'New Records',
        count: responseData?.newRecords,
      },
      {
        key: '2',
        description: 'Updated Records',
        count: responseData?.updatedRecords,
      },
      {
        key: '3',
        description: 'Old Records',
        count: responseData?.oldRecords,
      },
      {
        key: '4',
        description: 'New Companies',
        count: responseData?.newCompanies,
      },
      {
        key: '5',
        description: 'Old Companies',
        count: responseData?.oldCompanies,
      },
      {
        key: '6',
        description: 'Total Records',
        count: responseData?.totalRecords,
      },
      {
        key: '7',
        description: 'Total Companies',
        count: responseData?.totalCompanies,
      },
    ];
  };

  render() {
    const { getFormColumns, isTabView, renderInstructions } =
      this.props.children;
    const { onSubmitForm, isView, formData, onFilterData } = this.props;
    const { selectedTab, loading, apiData } = this.state;
    const formsFiled = isTabView
      ? getFormColumns()[selectedTab].getChiledForm()
      : getFormColumns();
    const { api, updateOrCreateAPI, canCloseForm, storeObject, addedByKey } =
      isTabView ? getFormColumns()[selectedTab] : this.props.children;
    const fields = this.getDefaultFields();

    const columns = [
      {
        title: 'Description',
        dataIndex: 'description',
        key: 'description',
      },
      {
        title: 'Count',
        dataIndex: 'count',
        key: 'count',
      },
    ];
    return (
      <>
        <Formik
          enableReinitialize={false}
          initialValues={fields}
          validationSchema={() => {
            const formicErrors: any = {};
            formsFiled.map((x) => {
              if (x.isRequired && x.type !== 'form') {
                formicErrors[x.dataIndex] = Yup.string().required(
                  'This field is required'
                );
              } else if (x.type == 'form') {
                const obj = {};
                x.form[0].forEach(ele => {
                  if (ele.isRequired) {
                    obj[ele.dataIndex] = Yup.string().required('This field is required');
                  }
                });
                formicErrors[x.dataIndex] = Yup.array().of(
                  Yup.object().shape(obj)
                );
              }
            });
            return Yup.object().shape(formicErrors);
          }}
          onSubmit={async (values, { resetForm }) => {
            const { formData } = this.props;
            if (
              formData &&
              formData['_id'] &&
              apiData &&
              Object.keys(apiData).length
            ) {
              const responseData = await this.props.dispatch(
                putData(
                  `${isTabView ? updateOrCreateAPI : api()}/${apiData['_id']}`,
                  values
                )
              );
              if (responseData) {
                if (this.props.showResult) {
                  this.setState({ _responseData: this.getTableResponse(responseData.data) });
                  return;
                } else {
                  this.props.onCloseModal();
                  resetForm();
                }
              }
            } else {
              if (formData && formData['_id']) {
                values[addedByKey] = formData['_id'];
              }
              const responseData = await this.props.dispatch(
                postData(isTabView ? updateOrCreateAPI : api(), values)
              );
              if (responseData && responseData.code == 200) {
                openNotificationWithIcon(
                  'success',
                  'Success',
                  'Action Executed Successfully'
                );
                if (this.props.showResult) {
                  this.setState({ _responseData: this.getTableResponse(responseData.data) });
                  return;
                }
                if (storeObject) {
                  this.props.dispatch({
                    type: 'USER_FORM',
                    formData: responseData.data,
                  });
                }
                if ((isTabView && canCloseForm) || !isTabView) {
                  this.props.onCloseModal();
                  this.props.dispatch({
                    type: 'USER_FORM_DATA',
                    formData: null,
                    apiData: null,
                  });
                }
                resetForm();
              } else {
                openNotificationWithIcon(
                  'error',
                  'Error',
                  responseData.message
                );
              }
            }
          }}
          render={({ errors, touched, isSubmitting, submitForm, values }) => {
            console.log('errorserrorserrorserrors', errors);
            onSubmitForm(submitForm);
            if (onFilterData) {
              onFilterData(values);
            }

            return (
              <>
                {isTabView && (
                  <Tabs
                    defaultActiveKey={selectedTab}
                    onChange={this.setCurrentTabView}
                  >
                    {getFormColumns().map((ele, index) => (
                      <TabPane
                        tab={ele.tabName}
                        key={index}
                        disabled={!formData}
                      >
                        <Form className="content">
                          {!loading &&
                            this.getFormsInput(
                              errors,
                              touched,
                              isSubmitting,
                              fields,
                              isView,
                              values
                            )}
                        </Form>
                      </TabPane>
                    ))}
                  </Tabs>
                )}
                {!isTabView && (<>
                  <Form className="content">
                    {!loading &&
                      this.getFormsInput(
                        errors,
                        touched,
                        isSubmitting,
                        fields,
                        isView,
                        values
                      )}
                  </Form>
                  {this.state._responseData.length > 0 && this.props.showResult && <div>
                    <Table
                      columns={columns}
                      dataSource={this.state._responseData}
                      pagination={false}  // Disable pagination since there are few rows
                    />
                  </div>}
                </>
                )}
                {renderInstructions}
              </>
            );
          }}
        />
      </>
    );
  }
}

// export default SimpleForm;

const mapStateToProps = (state) => ({
  isAuthenticated: state.app.isAuthenticated,
  user: state.app.user,
  formData: state.app.formData,
  apiData: state.app.apiData,
  formInstructions: state.formInstructions,
});

export default connect(mapStateToProps)(SimpleForm);